import type { PropsWithChildren, ReactNode } from 'react';
import { cn } from '../lib/cn';

export function Card({
  title,
  subtitle,
  action,
  className,
  bodyClassName,
  children,
}: PropsWithChildren<{
  title?: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  className?: string;
  bodyClassName?: string;
}>): JSX.Element {
  return (
    <section className={cn('bg-surface border border-rule rounded-lg shadow-sm', className)}>
      {(title || subtitle || action) && (
        <header className="flex items-start justify-between gap-4 px-5 py-3 border-b border-rule">
          <div>
            {title && <h2 className="text-base font-semibold text-ink">{title}</h2>}
            {subtitle && <p className="text-xs text-ink-3 mt-0.5">{subtitle}</p>}
          </div>
          {action}
        </header>
      )}
      <div className={cn('px-5 py-4', bodyClassName)}>{children}</div>
    </section>
  );
}
